import { useEffect, useRef, useState } from "react";
import { Box, Typography, CircularProgress } from "@mui/material";
import { AxiosError } from "axios";
import apiService from "../../service/Api";

const JOB_CARD_FRONTEND_URL =
  process.env.REACT_APP_JOB_CARD_FRONTEND_URL || "http://localhost:5173";

interface IssueResponse {
  code: string;
}

export default function JobCardHandoff() {
  const [error, setError] = useState<string | null>(null);
  const attempted = useRef(false);

  useEffect(() => {
    if (attempted.current) return;
    attempted.current = true;

    apiService
      .post<IssueResponse>("/api/authentication/sso/issue/", { target: "job_card" })
      .then((res) => {
        window.location.href = `${JOB_CARD_FRONTEND_URL}/sso?code=${res.data.code}`;
      })
      .catch((err: unknown) => {
        console.error("Job Card handoff failed:", err);
        if (err instanceof AxiosError) {
          const status = err.response?.status;
          const message = err.response?.data?.message;
          if (status === 403) {
            setError(message || "You don't have access to Job Card.");
          } else if (status) {
            setError(`Handoff request failed (${status}): ${message || err.message}`);
          } else {
            setError(`Could not reach the server: ${err.message}`);
          }
        } else {
          setError("Something went wrong opening Job Card.");
        }
      });
  }, []);

  return (
    <Box
      sx={{
        minHeight: "60vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 2,
      }}
    >
      {error ? (
        <Typography sx={{ fontSize: "0.95rem" }}>{error}</Typography>
      ) : (
        <>
          <CircularProgress />
          <Typography sx={{ fontSize: "0.95rem" }}>Opening Job Card…</Typography>
        </>
      )}
    </Box>
  );
}
